import React, { ReactNode, Suspense } from 'react';

import LoadableRebrandingBanner from '../LoadableRebrandingBanner';

import { useShouldDisplayVivaEngageRebrandingBanner } from './useShouldDisplayVivaEngageRebrandingBanner';

type UseRebrandingBanner = () => ReactNode | null;
export const useRebrandingBanner: UseRebrandingBanner = () => {
  const shouldDisplayBanner = useShouldDisplayVivaEngageRebrandingBanner();

  const banner = (
    <Suspense fallback={null}>
      <LoadableRebrandingBanner />
    </Suspense>
  );

  return shouldDisplayBanner ? banner : null;
};
